<template>
  <div class="header">
    <div class="banner">
      <h1>
        <img src="../assets/images/logo.png" alt="爱介护" />
      </h1>
    </div>
    <div class="header_box">
      <ul>
        <li @click="li_show(1)" :class="isColor == 1 ? 'active' : ''">
          <p @click="li_show(1)">
            <!-- <router-link to="/">首页</router-link> -->首页
          </p>
        </li>
        <li @click="li_show(2)" :class="isColor == 2 ? 'active ' : ''">
          <p>
            <!-- <router-link to="/about">关于我们</router-link> -->
            关于我们
          </p>
          <!-- <div class="hides">
            <ul class="ul_hide">
              <li>公司介绍</li>
              <li>发展历程</li>
              <li>员工风采</li>
              <li>合作伙伴</li>
            </ul>
          </div> -->
        </li>
        <li @click="li_show(3)" :class="isColor == 3 ? 'active' : ''">
          <p @click="li_show(3)">
            <!-- <router-link to="/newscenter">新闻中心</router-link> -->新闻中心
          </p>
        </li>
        <li @click="li_show(4)" :class="isColor == 4 ? 'active' : ''">
          <p @click="li_show(4)">
            <!-- <router-link to="/serve">服务项目</router-link> -->
            服务项目
          </p>
          <!-- <div class="hides">
            <ul class="ul_hide">
              <li>居家照顾</li>
              <li>长护险服务</li>
              <li>医院陪护</li>
              <li>老年餐定制</li>
              <li>适老化改造</li>
            </ul>
          </div> -->
        </li>
        <li @click="li_show(5)" :class="isColor == 5 ? 'active' : ''">
          <p class="site1">
            <!-- <router-link to="/site">服务站点</router-link> -->
            服务站点
          </p>
          <!-- <div class="hides">
            <ul class="ul_hide">
              <li>爱介护公司</li>
              <li>护理站</li>
              <li>社区服务机构</li>
              <li>
                <router-link to="/site"> 服务站点</router-link>
              </li>
            </ul>
          </div> -->
        </li>
        <li @click="li_show(6)" :class="isColor == 6 ? 'active' : ''">
          <p @click="li_show(6)">
            <!-- <router-link to="/join">加入我们</router-link> -->加入我们
          </p>
          <!-- <div class="hides">
            <ul class="ul_hide" @click="li_show(6)">
              <li>招贤纳士</li>
              <li>异业合作</li>
              <li>志愿者服务</li>
            </ul>
          </div> -->
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isColor: 1
    };
  },
  methods: {
    li_show(e) {
      this.isColor = e;
      sessionStorage.setItem("navigatorNum", e);
      // console.log(e);
      if (e == 1) {
        this.$router.push("/");
      } else if (e == 2) {
        this.$router.push("/about");
      } else if (e == 3) {
        this.$router.push("/newscenter");
      } else if (e == 4) {
        this.$router.push("/serve");
      } else if (e == 5) {
        this.$router.push("/site");
      } else if (e == 6) {
        this.$router.push("/join");
      }
    }
  },
  created() {
    if (sessionStorage.getItem("navigatorNum") == null) {
      this.isColor = 1;
    } else {
      this.isColor = sessionStorage.getItem("navigatorNum");
    }
  },
  mounted() {
    this.$EventBus.$on("nums", val => {
      // console.log(val);
      this.isColor = val;
      sessionStorage.setItem("navigatorNum", val);
    });
  }
};
</script>

<style scoped>
.header {
  height: 156px;
  display: flex;
  padding: 0 10%;
  justify-content: space-between;
  align-items: center;
  font-size: 20px;
  font-family: "SourceHanSansCNRegular";
  background-color: #fff;
}

.banner img {
  width: 397px;
  height: 66px;
}

.active {
  background-color: #f29800;
  border-radius: 30px;
}
.active > p {
  color: #fff !important;
}

.header_box > ul > li > p {
  display: inline-block;
  width: 100%;
  color: black;
}
.header_box > ul > li > p {
  width: 100%;
}
.header_box > ul > li > p :hover {
  color: #fff;
}
.active_child {
  display: block;
}
.header_box > ul {
  display: flex;
}
.header_box > ul > li {
  padding: 4px 0px;
  width: 108px;
  margin: 0 20px;
  cursor: pointer;
  position: relative;
}
.header_box > ul > li:hover {
  background-color: #f29800;
  border-radius: 30px;
}
.header_box > ul > li:hover .hides {
  display: block;
}
.header_box .hides {
  position: absolute;
  top: 38px;
  left: 0;
  width: 100%;
  height: 64px;
  display: none;
  z-index: 22332;
}
.header_box .ul_hide {
  position: absolute;
  top: 58px;
  left: -30px;
  width: 180px;
  text-align: center;
  background-color: #fff;
  border-radius: 10px;
  padding: 10px;
}
.header_box .ul_hide li {
  padding: 6px;
}
.header_box .ul_hide li a:hover {
  color: #f29800;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue